import React from 'react'
import { TableRow, TableCell, TextField, Box, Typography } from '@mui/material'
import { Button } from 'reactstrap'
import { ImBin2 } from 'react-icons/im'
import { useResumenTables } from '../../context/ResumenTablesContext'


const ResumenRow = ({ item, index, data, setData, isConstruccion, totalSum }) => {
  const {
    numeroDivision,
        formatNumber,
        handleBlur,
        handleRemoveRow,
        totalMo,
        modulos,
  } = useResumenTables()

  const isIndustrial =
    isConstruccion && item.name?.toLowerCase() === 'fabricacion industrial'

  const industrialValue = modulos
    ? modulos.modulos.reduce((acc, m) => acc + Number(m.totalImport), 0) + Number(totalMo)
    : 0

  const displayValue = isIndustrial ? industrialValue : Number(item.value || 0)
  const perUnit = (displayValue / numeroDivision).toFixed(2)
  const percentage = totalSum > 0
    ? ((displayValue / totalSum) * 100).toFixed(2)
    : 0

  return (
    <TableRow key={index}>
      <TableCell sx={{ padding: '8px 16px', width: '32%' }}>
        <TextField
          value={item.name}
          onChange={e => {
            const updated = [...data]
            updated[index].name = e.target.value
            setData(updated)
          }}
          onBlur={handleBlur}
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Nombre del concepto"
          required
          disabled={isIndustrial}
        />
      </TableCell>

      <TableCell align="right" sx={{ padding: '8px 16px', width: '20%' }}>
        {isIndustrial ? (
          <Typography sx={{ marginLeft: '8px', color: '#6c757d', fontSize: '1.2rem', fontWeight: 'bold' }}>
            {formatNumber(industrialValue)}€
          </Typography>
        ) : (
          <TextField
            value={item.value}
            onChange={e => {
              const updated = [...data]
              updated[index].value = e.target.value
              setData(updated)
            }}
            onBlur={handleBlur}
            fullWidth
            variant="outlined"
            size="small"
            type="number"
            required
            placeholder="0,00"
          />
        )}
      </TableCell>

      <TableCell align="right" sx={{ padding: '8px 16px', width: '20%' }}>
        <Box display="flex" alignItems="center">
          <Typography sx={{ fontSize: '1.2rem', color: '#6c757d', fontWeight: 'bold', textAlign: 'right', flexGrow: 1 }}>
            {perUnit}
          </Typography>
          <Typography sx={{ marginLeft: '8px', color: '#6c757d', fontSize: '1.2rem', fontWeight: 'bold' }}>
            €/m²
          </Typography>
        </Box>
      </TableCell>

      <TableCell align="right" sx={{ padding: '8px 20px', width: '15%' }}>
        <Typography sx={{ fontSize: '1.2rem', color: '#6c757d', fontWeight: 'bold', textAlign: 'right' }}>
          {`${formatNumber(percentage)} %`}
        </Typography>
      </TableCell>

      {!isIndustrial && (
        <TableCell align="right" sx={{ padding: '8px 16px', width: '5%' }}>
          <Button style={{ padding: '4px 6px', marginLeft: '8px' }} onClick={() => handleRemoveRow(data, setData, index)}>
            <ImBin2 style={{ fontSize: '1.1rem' }} />
          </Button>
        </TableCell>
      )}
    </TableRow>
  )
}

export default ResumenRow
